import { FC, memo } from 'react'
import { Text, useColorModeValue } from '@chakra-ui/react'

type Props = {
  value?: string
  label?: string
}

const Span: FC<Props> = ({ label, value }) => {
  return (
    <Text as="span" color="dark" variant="secondary">
      {label}
      <Text as="span" fontSize="xs" color={useColorModeValue('gray.500', 'whiteAlpha.700')}>
        {value}
      </Text>
    </Text>
  )
}

export default memo(Span)
